import styled, {keyframes} from 'styled-components';
import {Col} from 'reactstrap';


export const Block = styled.div`
  background: #fff;
  border-radius: 8px;
  padding: 40px;
  box-shadow: 0 0px 5px 0px rgba(65,65,65,0.2);
  margin-bottom: 200px
`;

export const SmallBlock = styled.div`
  background: #fff;
  border-radius: 8px;
  padding: 5px;
  box-shadow: 0 0px 5px 0px rgba(65,65,65,0.2);
  margin-bottom: 5px;
  margin-right: 20px
`;


export const ProgressState = styled.div`
  ${({progress}) => {
    const states = {
      completed: opacity => `rgba(40, 181, 54, ${opacity})`,
      inProgress: opacity => `rgba(250, 165, 2, ${opacity})`,
      started: opacity => `rgba(250, 165, 2, ${opacity})`,
      notStarted: opacity => `rgba(219, 53, 69, ${opacity})`,
      unavailable: opacity => `rgba(190, 190, 190, ${opacity})`,
      disabled: opacity => `rgba(219, 53, 69, ${opacity})`,
      available: opacity => `rgba(53, 219, 2, ${opacity})`,
    };

    return `
      border: 1px solid ${states[progress](1)};
      background: ${states[progress](0.3)};
      color: ${states[progress](1)};
    `;
  }}
  height: 30px;
  line-height: 30px;
  border-radius: 100px;
  margin-top: 20px;
  max-width: 180px;
  width: 100%;
  display: inline-block;
  font-weight: 900;
  font-size: 14px;
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const FadeCol = styled(Col)`
  animation: ${fadeIn} 0.5s forwards 1;
  opacity: 0;
`;

export const FormSymbol = styled.div`
  position: absolute;
  top: 1px;
  left: 1px;
  height: 36px;
  width: 38px;
  background: #ccc;
  color: #fff;
  font-weight: bold;
  text-align: center;
  line-height: 38px;
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
`;